/** Strip spaces and non-digit characters for phone search/compare. */
export function normalizePhoneDigits(
  phone: string | number | null | undefined
): string {
  if (phone == null || phone === "") return "";
  return String(phone).replace(/\D/g, "");
}
